import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 1,
  class: "hotel-list"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "center-wrapper"
}
const _hoisted_7 = {
  key: 2,
  class: "hotel-list",
  role: "alert"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = {
  key: 4,
  class: "hotel-list"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterOverview = _resolveComponent("FilterOverview")!
  const _component_TravelSorting = _resolveComponent("TravelSorting")!
  const _component_TravelList = _resolveComponent("TravelList")!
  const _component_DotSpinner = _resolveComponent("DotSpinner")!
  const _component_IconSpinner = _resolveComponent("IconSpinner")!
  const _component_GifSpinner = _resolveComponent("GifSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.searchTravelResponse && _ctx.searchTravelResponse.searchFilter)
      ? (_openBlock(), _createBlock(_component_FilterOverview, {
          key: 0,
          filter: _ctx.searchTravelResponse.searchFilter,
          isIdle: _ctx.isResultListLoading,
          searchTravelRequest: _ctx.searchTravelRequest,
          pageTexts: _ctx.pageTexts,
          localeStrings: _ctx.localeStrings,
          onUpdateFilterStars: _ctx.updateFilterStars,
          onUpdateFilterCategories: _ctx.updateFilterCategories,
          onUpdateFilterMinimumPrice: _ctx.updateFilterMinimumPrice,
          onUpdateFilterMaximumPrice: _ctx.updateFilterMaximumPrice,
          onUpdateFilterQuery: _ctx.updateFilterQuery,
          onUpdateFilters: _ctx.updateFilters,
          onUpdateFilterPriceRange: _ctx.updateFilterPriceRange
        }, null, 8, ["filter", "isIdle", "searchTravelRequest", "pageTexts", "localeStrings", "onUpdateFilterStars", "onUpdateFilterCategories", "onUpdateFilterMinimumPrice", "onUpdateFilterMaximumPrice", "onUpdateFilterQuery", "onUpdateFilters", "onUpdateFilterPriceRange"]))
      : _createCommentVNode("", true),
    (_ctx.searchTravelResponse && _ctx.searchTravelResponse.travels && !_ctx.isResultListLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("header", null, [
            (_ctx.searchTravelResponse.travels.length)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.filterHeadline), 1))
              : (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.pageTexts['hotelListPageSearchNoResultHeadline']), 1)),
            (_ctx.searchTravelResponse.travels.length)
              ? (_openBlock(), _createBlock(_component_TravelSorting, {
                  key: 2,
                  sortItems: _ctx.searchTravelResponse.sorting.items,
                  pageTexts: _ctx.pageTexts,
                  onUpdateSort: _ctx.updateSort
                }, null, 8, ["sortItems", "pageTexts", "onUpdateSort"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.searchTravelResponse.travels.length)
            ? (_openBlock(), _createBlock(_component_TravelList, {
                key: 0,
                travels: _ctx.searchTravelResponse.travels,
                pageTexts: _ctx.pageTexts,
                localeStrings: _ctx.localeStrings
              }, null, 8, ["travels", "pageTexts", "localeStrings"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "rte",
                innerHTML: _ctx.pageTexts['hotelListPageSearchNoResultSubHeadline']
              }, null, 8, _hoisted_5)),
          (_ctx.searchTravelResponse.paging.numberOfPages >
        _ctx.searchTravelResponse.paging.pageNumber
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-secondary show-more-btn", { 'loading': _ctx.isPageLoading }]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMoreTravels && _ctx.showMoreTravels(...args)))
                }, [
                  (_ctx.isPageLoading)
                    ? (_openBlock(), _createBlock(_component_DotSpinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelListPageSearchResultLabelShowMoreHotels']), 1)
                      ], 64))
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.hasNoRequest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchNoResultQueryErrorHeadline']), 1),
            _createElementVNode("div", {
              class: "rte",
              innerHTML: _ctx.pageTexts['hotelListPageSearchNoResultQueryErrorText']
            }, null, 8, _hoisted_8)
          ]))
        : (_ctx.hasResponseError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchNoResultResponseErrorHeadline']), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.responseErrorMessage), 1)
            ]))
          : (_ctx.searchTravelResponse.searchFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                  return _createElementVNode("div", {
                    class: "skeleton",
                    key: index
                  }, [
                    _createVNode(_component_IconSpinner, { iconUrl: '/public/assets/img/icons/spinner_island.svg' }, null, 8, ["iconUrl"])
                  ])
                }), 64))
              ]))
            : (!_ctx.searchTravelResponse.searchFilter)
              ? (_openBlock(), _createBlock(_component_GifSpinner, {
                  key: 5,
                  iconUrl: '/public/assets/img/letsdo_loading.gif'
                }, null, 8, ["iconUrl"]))
              : _createCommentVNode("", true)
  ]))
}